import { TextField, Typography, makeStyles } from "@material-ui/core";
import moment from 'moment';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    dateSelectBetween: {
        alignSelf: 'center'
    }
}));

function DateRangePicker(props) {
    const { fromDateLabel, toDateLabel, dateFormat, type } = props;
    const { textFieldProps, textFieldStyle, className, style } = props;
    const { fromDateValue, toDateValue } = props;
    const { handleDateChange } = props;

    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <div className={className} style={style}>
            <TextField
                id="from"
                label={fromDateLabel || t("common:from_date")}
                type={type === "minutes" ? "datetime-local" : "date"}  
                variant="outlined"
                value={fromDateValue.format(type === "minutes" ? "YYYY-MM-DDTHH:mm" : dateFormat)} 
                onChange={handleDateChange}
                fullWidth
                style={textFieldStyle}
                {...textFieldProps}
            />
            <Typography className={classes.dateSelectBetween} color='textPrimary'> - </Typography>
            <TextField
                id="to"
                label={toDateLabel || t("common:to_date")}
                type={type === "minutes" ? "datetime-local" : "date"}  
                variant="outlined"
                value={toDateValue.format(type === "minutes" ? "YYYY-MM-DDTHH:mm" : dateFormat)} 
                onChange={handleDateChange}
                fullWidth
                style={textFieldStyle}
                {...textFieldProps}
            />
        </div>
    )
}

DateRangePicker.defaultProps = {
    dateFormat: "YYYY-MM-DD",
    fromDateValue: moment(),
    toDateValue: moment(),
    type: "date",
    handleDateChange: () => {}
}

export default DateRangePicker;
